import InstrumentSkeleton from "./InstrumentSkeleton/InstrumentSkeleton";

const PageSkeleton = () => <InstrumentSkeleton />;

export default PageSkeleton;
